import { appConfig, userData } from '../service/config';

export class NavMailcheck extends HTMLElement{

  connectedCallback(): void {
    const el = this.querySelector('#unitedinternet_toolbar');
    /* istanbul ignore next else */
    if (el) {
      el.setAttribute('session-alive', 'true')
      el.setAttribute('primary_mail_address', userData.email);
      /* istanbul ignore next else */
      if (appConfig.thirdParty && appConfig.thirdParty.navigator && appConfig.thirdParty.navigator.startup) {
        el.setAttribute('event_data_to_page', appConfig.thirdParty.navigator.startup.toolbarevent);
      }
    }
  }

}

window.customElements.define('nav-mail-check', NavMailcheck);
